/**
 * -=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=
 * Sectors - Kinihira 
 * -=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=
 */
module.exports = {
  "Butunzi": ["Akamiyove", "Barayi", "Bunahi", "Gisekuru", "Kinihira", "Ndorandi"],
  "Karegamazi": ["Buhita", "Bwishya", "Gatembe", "Magezi", "Mutoyi", "Ntunguru"],
  "Marembo": ["Buhunde", "Cyogo", "Gatare", "Kigali", "Kiyebe"],
  "Rebero": ["Kabuga", "Karambi", "Kirwa", "Ndusu", "Rugundu", "Taba"]
};